// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner-37mCL","title":"title-3n-h1"};